import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Dropdown, Button as B_Button, Modal } from 'react-bootstrap';
import CachedIcon from '@mui/icons-material/Cached';
import { Button, IconButton, Typography, Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core';
import { Modal as B_Modal, Form } from "react-bootstrap";
import { saveNotes, getNotes, saveWrittenNotes } from "../../../services/notesService";
import html2pdf from 'html2pdf.js';
import { saveAs } from 'file-saver';
import { asBlob } from 'html-docx-js-typescript';
import { toast } from 'react-toastify';
import DownloadIcon from '@mui/icons-material/Download';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DescriptionIcon from '@mui/icons-material/Description';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import "./CoAuthor_Notes.css";

const modernStyles = {
  container: {
    padding: '20px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px',
    padding: '12px 16px',
    borderRadius: '12px',
    border: '1px solid',
  },
  headerTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '16px',
    fontWeight: 600,
  },
  actionButtons: {
    display: 'flex',
    gap: '8px',
  },
  iconButton: {
    padding: '8px 16px',
    borderRadius: '10px',
    border: 'none',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    outline: 'none',
  },
  textareaContainer: {
    flex: 1,
    position: 'relative',
    borderRadius: '12px',
    border: '2px solid',
    overflow: 'hidden',
  },
  textarea: {
    width: '100%',
    height: '100%',
    padding: '16px',
    border: 'none',
    outline: 'none',
    fontSize: '14px',
    lineHeight: '1.6',
    resize: 'none',
    fontFamily: 'inherit',
  },
  placeholder: {
    position: 'absolute',
    top: '16px',
    left: '16px',
    pointerEvents: 'none',
    opacity: 0.5,
    fontSize: '14px',
  },
  characterCount: {
    position: 'absolute',
    bottom: '12px',
    right: '16px',
    fontSize: '12px',
    padding: '4px 8px',
    borderRadius: '6px',
    fontWeight: 500,
  },
  modal: {
    textAlign: 'center',
  },
  modalTitle: {
    fontSize: '20px',
    fontWeight: 600,
    marginBottom: '8px',
  },
  modalSubtitle: {
    fontSize: '14px',
    marginBottom: '24px',
  },
  downloadButton: {
    padding: '12px 32px',
    borderRadius: '12px',
    border: 'none',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    margin: '0 8px',
  },
};

export const Coauthor_Notescomponent = ({ noteInput, handleTextInput }) => {
  const email = sessionStorage.getItem("currentUserEmail");
  const [notesData, setNotesData] = useState(() => sessionStorage.getItem('notesData') || '');
  const [downloadModal, setDownloadModal] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    const updateTheme = () => {
      const theme = localStorage.getItem('ThemeSwitch');
      setIsDarkMode(theme === 'true');
    };
    updateTheme();
    window.addEventListener('storage', updateTheme);
    const originalSetItem = localStorage.setItem;
    localStorage.setItem = function (key, value) {
      originalSetItem.apply(this, arguments);
      if (key === 'ThemeSwitch') {
        updateTheme();
      }
    };
    return () => {
      window.removeEventListener('storage', updateTheme);
      localStorage.setItem = originalSetItem;
    };
  }, []);

  const openDownloadModal = () => {
    if (!notesData) {
      toast.error('Notes is empty');
      return;
    }
    setDownloadModal(true);
  };

  const closeDownloadModal = () => {
    setDownloadModal(false);
  };

  const handleTextChange = (e) => {
    const updatedNoteInput = e.target.value;
    handleTextInput(updatedNoteInput);
    setNotesData(updatedNoteInput);
    sessionStorage.setItem('notesData', updatedNoteInput);
  };

  const handleClearAll = () => {
    if (!notesData) {
      toast.info('Notes is already empty');
      return;
    }
    // if (window.confirm('Are you sure you want to clear all notes?')) {
      setNotesData('');
      sessionStorage.setItem('notesData', '');
      toast.success('Notes cleared successfully');
    // }
  };

  useEffect(() => {
    const fetchData = () => {
      try {
        const sessionData = sessionStorage.getItem('notesData');
        if (sessionData) {
          setNotesData(sessionData);
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, [email]);

  const replaceUnderscoresWithHr = (text) => {
    return text.replace(/_{3,}/g, '<hr/>').replace(/\n/g, '<br/>');
  };

  const downloadNotesAsPDF = () => {
    const pdfContent = `
      <div>
        <h5>Notes</h5>
        <p>${replaceUnderscoresWithHr(notesData)}</p>
      </div>`;

    const element = document.createElement('div');
    element.innerHTML = pdfContent;

    html2pdf(element, {
      margin: 10,
      filename: 'Notes.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
    }).then(() => {
      closeDownloadModal();
      toast.success('PDF downloaded successfully');
    });
  };

  const downloadNotesAsWord = () => {
    const htmlString = `<!DOCTYPE html>
    <html lang="en">
    <head>
        <meta charset="UTF-8">
        <title>Notes</title>
    </head>
    <body>
        <h3>Notes</h3>
        <p>${replaceUnderscoresWithHr(notesData)}</p>
    </body>
    </html>`;

    asBlob(htmlString).then(docx => {
      saveAs(docx, 'Notes.docx');
      closeDownloadModal();
      toast.success('Word document downloaded successfully');
    });
  };

  const wordCount = notesData.trim() ? notesData.trim().split(/\s+/).length : 0;
  const charCount = notesData.length;

  return (
    <>
      <div
        style={{
          ...modernStyles.container,
          backgroundColor: isDarkMode ? '#1a1a1a' : '#fff',
          color: isDarkMode ? '#e5e7eb' : '#111',
        }}
      >
        {/* Header */}
        <div
          style={{
            ...modernStyles.header,
            borderColor: isDarkMode ? '#374151' : '#e5e7eb',
            backgroundColor: isDarkMode ? '#2a2a2a' : '#f9fafb',
          }}
        >
          <div style={modernStyles.headerTitle}>
            <DescriptionIcon style={{ fontSize: '20px', color: '#ff6f00' }} />
            <span>My Notes</span>
          </div>

          <div style={modernStyles.actionButtons}>
            {/* Download Button */}
            <button
              onClick={openDownloadModal}
              style={{
                ...modernStyles.iconButton,
                backgroundColor: '#667eea',
                color: '#fff',
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#5568d3'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#667eea'}
            >
              <DownloadIcon style={{ fontSize: '18px' }} />
              Download
            </button>

            {/* Clear Button */}
            <button
              onClick={handleClearAll}
              style={{
                ...modernStyles.iconButton,
                backgroundColor: isDarkMode ? '#7f1d1d' : '#fee2e2',
                color: '#ef4444',
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = isDarkMode ? '#991b1b' : '#fecaca';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = isDarkMode ? '#7f1d1d' : '#fee2e2';
              }}
            >
              <DeleteOutlineIcon style={{ fontSize: '18px' }} />
              Clear All
            </button>
          </div>
        </div>

        {/* Textarea Container */}
        <div
          style={{
            ...modernStyles.textareaContainer,
            borderColor: isDarkMode ? '#374151' : '#e5e7eb',
            backgroundColor: isDarkMode ? '#2a2a2a' : '#fff',
          }}
        >
          <textarea
            value={notesData}
            onChange={handleTextChange}
            placeholder="Start typing your notes here..."
            style={{
              ...modernStyles.textarea,
              backgroundColor: isDarkMode ? '#2a2a2a' : '#fff',
              color: isDarkMode ? '#e5e7eb' : '#111',
            }}
          />

          {/* Character and Word Count */}
          {notesData && (
            <div
              style={{
                ...modernStyles.characterCount,
                backgroundColor: isDarkMode ? '#374151' : '#f3f4f6',
                color: isDarkMode ? '#9ca3af' : '#6b7280',
              }}
            >
              {wordCount} words • {charCount} characters
            </div>
          )}
        </div>
      </div>

      {/* Download Modal */}
      <Modal
        show={downloadModal}
        onHide={closeDownloadModal}
        centered
        style={{ zIndex: 9999 }}
      >
        <Modal.Body
          style={{
            padding: '32px',
            backgroundColor: isDarkMode ? '#2a2a2a' : '#fff',
            borderRadius: '16px',
          }}
        >
          <div style={modernStyles.modal}>
            <div
              style={{
                width: '64px',
                height: '64px',
                margin: '0 auto 20px',
                borderRadius: '50%',
                backgroundColor: isDarkMode ? '#374151' : '#f3f4f6',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <DownloadIcon
                style={{
                  fontSize: '32px',
                  color: '#667eea',
                }}
              />
            </div>

            <h3
              style={{
                ...modernStyles.modalTitle,
                color: isDarkMode ? '#e5e7eb' : '#111',
              }}
            >
              Download Notes
            </h3>
            <p
              style={{
                ...modernStyles.modalSubtitle,
                color: isDarkMode ? '#9ca3af' : '#6b7280',
              }}
            >
              Choose your preferred format
            </p>

            <div style={{ display: 'flex', justifyContent: 'center', gap: '12px' }}>
              <button
                onClick={downloadNotesAsPDF}
                style={{
                  ...modernStyles.downloadButton,
                  backgroundColor: '#ef4444',
                  color: '#fff',
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#dc2626'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#ef4444'}
              >
                <PictureAsPdfIcon style={{ fontSize: '20px' }} />
                PDF
              </button>

              <button
                onClick={downloadNotesAsWord}
                style={{
                  ...modernStyles.downloadButton,
                  backgroundColor: '#3b82f6',
                  color: '#fff',
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#2563eb'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#3b82f6'}
              >
                <DescriptionIcon style={{ fontSize: '20px' }} />
                Word
              </button>
            </div>

            <button
              onClick={closeDownloadModal}
              style={{
                marginTop: '20px',
                padding: '10px 24px',
                backgroundColor: 'transparent',
                border: `2px solid ${isDarkMode ? '#374151' : '#e5e7eb'}`,
                borderRadius: '10px',
                color: isDarkMode ? '#9ca3af' : '#6b7280',
                fontSize: '14px',
                fontWeight: 600,
                cursor: 'pointer',
              }}
            >
              Cancel
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};